module.exports = __webpack_public_path__ + "img/4.85e9647a.jpg";